/*
 * Signing in to an MCP server with its provider. The address comes from the
 * server; it opens in a popup, the provider sends the browser to the builder,
 * the builder hands the tokens to aibot and the popup posts `aa:mcp-oauth-done`
 * before closing. Only that message, from the builder, counts as signed in: a
 * popup closed without it finishes as not signed in, and the caller reloads
 * the list, which shows the real state.
 *
 * The window is opened in the click itself, before the address is fetched:
 * a popup opened after an await can land outside the browser's click window
 * and be blocked without a word, leaving the button waiting for nothing.
 */
export const MCP_OAUTH_DONE = 'aa:mcp-oauth-done';

export const POPUP_BLOCKED = 'Your browser blocked the sign-in window. Allow pop-ups for this site and try again.';

const BUILDER_ORIGIN = new URL((process.env.REACT_APP_BUILDER_URL as string | undefined) || 'https://builder.agentsanywhere.ai').origin;

const fromBuilder = (origin: string): boolean => origin === BUILDER_ORIGIN || origin === window.location.origin;

export function prepareMcpSignIn(): Window | null {
  return window.open('about:blank', 'aa-mcp-oauth', 'width=980,height=760');
}

export function openMcpSignIn(popup: Window, authorizeUrl: string, onDone: (ok: boolean) => void): () => void {
  popup.location.href = authorizeUrl;
  let finished = false;
  const finish = (ok: boolean) => {
    if (finished) return;
    finished = true;
    window.removeEventListener('message', onMessage);
    window.clearInterval(watch);
    onDone(ok);
  };
  const onMessage = (event: MessageEvent) => {
    if (!fromBuilder(event.origin)) return;
    if (event?.data?.type !== MCP_OAUTH_DONE) return;
    finish(event.data.ok !== false);
  };
  window.addEventListener('message', onMessage);
  const startedAt = Date.now();
  const watch = window.setInterval(() => {
    if (popup.closed) finish(false);
    if (Date.now() - startedAt > 5 * 60_000) finish(false);
  }, 1000);
  return () => finish(false);
}
